import { Fragment } from "react";
import { useResponseContext } from "zudoku";
import { Item, ItemContent, ItemGroup, ItemSeparator, ItemTitle } from "zudoku/ui/Item.js";

type HeaderDef = {
  description?: string;
  schema?: { type?: string; format?: string; enum?: string[] };
};

export const ResponseHeadersSlot = () => {
  const response = useResponseContext();
  if (!response?.headers) return null;

  const headers = response.headers as Record<string, HeaderDef>;
  const entries = Object.entries(headers);
  if (entries.length === 0) return null;

  return (
    <div className="border-t">
      <ItemGroup>
        {entries.map(([name, def], index) => (
          <Fragment key={name}>
            {index > 0 && <ItemSeparator />}
            <Item>
              <ItemContent className="gap-y-2">
                <div>
                  <ItemTitle className="inline me-2">
                    <code className="text-foreground">{name}</code>
                  </ItemTitle>
                  {"​"}
                  <span className="text-xs text-sky-600 dark:text-sky-400">header</span>
                  {def.schema?.type && (
                    <>
                      <span className="text-muted-foreground/50 text-xs">&nbsp;&middot;&nbsp;</span>
                      <span className="text-muted-foreground text-xs">
                        {def.schema.format
                          ? `${def.schema.type} (${def.schema.format})`
                          : def.schema.type}
                      </span>
                    </>
                  )}
                </div>
                {def.description && (
                  <p className="text-sm text-muted-foreground">{def.description}</p>
                )}
                {def.schema?.enum && (
                  <div className="flex flex-wrap gap-1">
                    {def.schema.enum.map((v) => (
                      <code key={v} className="rounded bg-muted px-1 py-0.5 text-xs">{v}</code>
                    ))}
                  </div>
                )}
              </ItemContent>
            </Item>
          </Fragment>
        ))}
      </ItemGroup>
    </div>
  );
};
